import {
  type LeadActivity,
  LeadVisibility,
} from '@up2stay/up2promo-api-client';

/** Runtime metadata on activity entries (not in generated OpenAPI types). */
export type LeadActivityMetadata = {
  from?: string;
  to?: string;
  field?: string;
  tag?: string;
  eventId?: string;
  eventName?: string;
  reason?: string;
  title?: string;
  /** Present when share+assign were combined into one assignee_changed activity. */
  sharedWithWorkspace?: string;
  /** Outbound contact channel for contacted_via (call | email | sms). */
  channel?: string;
  detail?: string;
};

export function getLeadActivityMetadata(
  entry: LeadActivity,
): LeadActivityMetadata {
  return (
    (entry as LeadActivity & { metadata?: LeadActivityMetadata | null })
      .metadata ?? {}
  );
}

/**
 * `workspace_sharing_updated` stores the lead visibility (`private` |
 * `workspace`) in `from` / `to`; activities logged before the visibility
 * model stored the old shared flag as `'true'` / `'false'`.
 */
export function isWorkspaceSharedActivityValue(
  value: string | null | undefined,
): boolean {
  return value === LeadVisibility.WORKSPACE || value === 'true';
}
